import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import TableCell from './TableCell';

const TableHeaderRow = ({ columnDefs, className }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const visibleColumns = isMobile ? columnDefs.slice(0, 1) : columnDefs;
  const lastIdx = visibleColumns.length - 1;

  return (
    <tr className={cn('h-8 border-0 border-b border-solid border-neutral-200', className)}>
      {visibleColumns.map((col, index) => (
        <TableCell
          key={String(col.field)}
          index={index}
          lastIdx={index > 0 ? lastIdx : null}
          className={cn('py-[6px] text-end', col?.cellClass)}
          style={{
            width: col.width || `${100 / visibleColumns.length}%`
          }}>
          {typeof col.headerName === 'function' ? (
            <col.headerName {...col} />
          ) : (
            <Typography
              variant="label"
              size="medium"
              weight="medium"
              className="whitespace-nowrap"
              color="neutral-700">
              {col.headerName}
            </Typography>
          )}
        </TableCell>
      ))}
    </tr>
  );
};

export default TableHeaderRow;
